'use strict';

angular.module('clientDashboardApp').factory('snapshotService', function ($http) {
  return {
    snapshotReport: function (groupId) {
      return $http.get('/dashboard/snapshotReport/' + groupId).then(response => response.data)
    }
  }
});
